export var UserType;
(function (UserType) {
    UserType["Human"] = "human";
    UserType["Machine"] = "machine";
})(UserType || (UserType = {}));
//# sourceMappingURL=User.js.map